import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography, Container, Paper } from '@mui/material';

export default function ReferralRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Store referral code in localStorage
    if (code) {
      localStorage.setItem('pendingReferralCode', code);
    }
    
    // Redirect to registration page after a brief moment
    const timer = setTimeout(() => {
      navigate('/register?ref=' + code);
    }, 500);

    return () => clearTimeout(timer);
  }, [code, navigate]);

  return (
    <Container component="main" maxWidth="sm">
      <Paper elevation={3} sx={{ p: 4, mt: 8, textAlign: 'center' }}>
        <CircularProgress sx={{ mb: 2 }} />
        <Typography variant="h6" gutterBottom>
          Обработка реферальной ссылки...
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Перенаправление на страницу регистрации
        </Typography>
      </Paper>
    </Container>
  );
}
